import {Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
    selector: 'youtube-player',
    templateUrl: './youtube-player.component.html',
    styleUrls: ['./youtube-player.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class YouTubePlayerComponent implements OnChanges {
  @Input() videoId: string;
  videoUrl: SafeResourceUrl;

  constructor(private readonly domSanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.videoId) {
      this.videoUrl = this.getVideoUrl(this.domSanitizer, this.videoId);
    }
  }

  getVideoUrl(domSanitizer: DomSanitizer, videoId: string): SafeResourceUrl {
    return domSanitizer.bypassSecurityTrustResourceUrl(
        `https://www.youtube-nocookie.com/embed/${videoId}`);
  }
}
